import React, { useState } from 'react'
import { FormattedMessage } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import { Form, FieldLocationAutocompleteInput, FieldDateRangePicker } from '../../components';

import heroImage from '../../assets/images/searchIcon.svg';
import css from './LandingPageNew.module.css';
import { getStartOf } from '../../util/dates';


const SearchBarForm = (props) => {
  const { intl, handleSubmit, initialValues, ...rest } = props || {}
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  const identity = v => v;
  const startDatePlaceholderText = "Add dates";
  const endDatePlaceholderText = "Add dates";

  return (
    <FinalForm
      {...rest}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      render={({ handleSubmit, values, form }) => {

        const onSearchClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Only accept location if it was SELECTED from dropdown
          // This ensures we have proper bounds and address data
          const hasLocationSelected = values?.location?.search && 
                                      values?.location?.selectedPlace?.address;
          
          // Check if user typed something but didn't select
          let hasTypedWithoutSelection = false;
          const locationInputs = document.querySelectorAll('input[name="location"]');
          if (locationInputs && locationInputs.length > 0) {
            const inputValue = locationInputs[0]?.value?.trim();
            hasTypedWithoutSelection = inputValue && inputValue.length > 0 && !hasLocationSelected;
          }

          console.log('Validation:', {
            hasLocationSelected,
            hasTypedWithoutSelection,
            location: values?.location
          });

          // Case 1: Nothing entered
          if (!hasLocationSelected && !hasTypedWithoutSelection) {
            setErrorMessage('Please enter a location in the "Where" field to continue');
            setShowError(true);
            return;
          }

          // Case 2: Typed but didn't select from dropdown
          if (hasTypedWithoutSelection) {
            setErrorMessage('Please select a location from the dropdown suggestions');
            setShowError(true);
            return;
          }

          // Case 3: Valid location selected
          setShowError(false);
          setErrorMessage('');
          handleSubmit(values);
        };

        return (
          <>
            {showError && (
              <div style={{
                backgroundColor: '#fee2e2',
                border: '2px solid #dc2626',
                borderRadius: '8px',
                color: '#dc2626',
                padding: '12px 16px',
                marginBottom: '16px',
                fontSize: '14px',
                fontWeight: '600',
                textAlign: 'center',
                maxWidth: '600px',
                margin: '0 auto 16px auto'
              }}>
                ⚠️ {errorMessage}
              </div>
            )}
            
            <Form className={css.searchBarForm}>
              <div className={css.searchBarRow}>
                <div className={css.searchInputBox}>
                  <label><FormattedMessage id="LandingPage.Search.Where" /></label>
                  <FieldLocationAutocompleteInput
                    rootClassName={css.locationAddress}
                    inputClassName={css.locationAutocompleteInput}
                    iconClassName={css.locationAutocompleteInputIcon}
                    predictionsClassName={css.predictionsRoot}
                    name="location"
                    placeholder={intl.formatMessage({ id: 'LandingPage.Where.placeHolder' })}
                    useDefaultPredictions={false}
                    format={identity}
                    valueFromForm={values?.location}
                    className={css.searchInputBoxIcon}
                    onChange={() => {
                      setShowError(false);
                      setErrorMessage('');
                    }}
                  />
                </div>
                <div className={css.searchInputBoxRow}>
                  <div className={css.searchInputBox}>
                    <FieldDateRangePicker
                      className={css.fieldDateInput}
                      name='bookingDates'
                      isDaily={false}
                      startDateId={intl.formatMessage({ id: 'LandingPage.Search.CheckIn' })}
                      startDateLabel='Check - In'
                      startDatePlaceholderText={startDatePlaceholderText}
                      endDateId='EmptyDateRange_bookingEndDate'
                      endDateLabel={intl.formatMessage({ id: 'LandingPage.Search.CheckOut' })}
                      endDatePlaceholderText={endDatePlaceholderText}
                      format={identity}
                      onChange={() => {
                        setShowError(false);
                        setErrorMessage('');
                      }}
                    />
                  </div>
                </div>
              </div>
              
              <div className={css.mobileSearchField}>
                <FieldLocationAutocompleteInput
                  rootClassName={css.locationAddress}
                  inputClassName={css.locationAutocompleteInput}
                  iconClassName={css.locationAutocompleteInputIcon}
                  predictionsClassName={css.predictionsMobileRoot}
                  name="location"
                  placeholder={intl.formatMessage({ id: 'LandingPage.Where.placeHolder' })}
                  useDefaultPredictions={false}
                  format={identity}
                  valueFromForm={values?.location}
                  className={css.searchInputBoxIcon}
                  onChange={() => {
                    setShowError(false);
                    setErrorMessage('');
                  }}
                />
              </div>
              
              <button 
                type="button" 
                onClick={onSearchClick} 
                className={css.searchBtn}
              >
                <img src={heroImage} alt="Search icon" />
              </button>
            </Form>
          </>
        );
      }}
    />
  )
}

export default SearchBarForm;